import { Fragment, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";

import HeaderPage from "../../../shared/components/HeaderPage/HeaderPage";
import SimpleTable from "../../../shared/components/common/ui/SimpleTable";

import { useChannelsData } from "../hooks/useChannelsData";
import ChannelsEmptyState from "../components/ChannelsEmptyState/ChannelsEmptyState";
import { getChannelsColumns } from "./ChannelOverviewTableColumns";
import { changeStatusChannel } from "../../../services/api/channels/utils/change-status";

export default function ChannelPageList() {
  const { channels, loading, isFetching, refetch } = useChannelsData();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.shouldRefetch) {
      refetch();
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, refetch, navigate, location.pathname]);

  function handleAdd() {
    navigate("/canais/adicionar");
  }

  const channelActions = [
    {
      label: "Configurar",
      icon: "settings",
      color: "primary",

      isVisible: (row) =>
        row.type === "whatsapp_api" || row.type === "whatsapp_web",

      onClick: (row) => {
        if (row.type !== "whatsapp_api" && row.type !== "whatsapp_web") return;

        navigate("/canais/configurar", {
          state: {
            channel: row,
          },
        });
      },
    },
    {
      label: "Remover",
      icon: "delete",
      color: "error",
      isVisible: () => true,
      onClick: async (row) => {
        const confirmed = window.confirm(
          `Deseja remover o canal "${row.instance_name}"?`,
        );
        if (!confirmed) return;

        await changeStatusChannel({
          channelId: row.id,
          status: "removed",
          type: row.type,
        });

        await refetch();
      },
    },
  ];

  return (
    <Fragment>
      <Box width="100%" height="100vh">
        <HeaderPage
          variant="listing"
          title="Canais"
          description="Gerencie os canais conectados para envio e atendimento das suas campanhas."
        />

        {!loading && !isFetching && channels.length === 0 ? (
          <ChannelsEmptyState onAdd={handleAdd} />
        ) : (
          <SimpleTable
            tableName="Canais"
            loading={loading}
            data={channels}
            columns={getChannelsColumns()}
            actions={channelActions}
            redirect={handleAdd}
            redirectText="Adicionar Canal"
            isFetching={isFetching}
            onRefresh={refetch}
            variant="listing"
          />
        )}
      </Box>
    </Fragment>
  );
}
